module.exports = __webpack_public_path__ + "img/logo_zju_new.c7a1cc81.png";